import {defaultsDeep} from 'es-toolkit/compat'

import defaultConfig from './default'

export default defaultsDeep(
  {
    services: {
      api: {
        baseUrl: 'http://localhost:8100',
      },
      partner: {
        baseUrl: 'http://localhost:8003',
      },
      craftcloud: {
        baseUrl: 'http://localhost:3001',
      },
      internal: {
        baseUrl: 'http://localhost:8008',
      },
    },
  },
  defaultConfig
)
